import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { MdArrowBack as BackIcon } from "react-icons/md";
import { MdArrowForward as ForwardIcon } from "react-icons/md";

import Viewer from "../UI/Viewer";
import ContentWrapper from "../UI/ContentWrapper";
import AppBar, { AppBarContentWrapper }  from "../AppBar/AppBar";
import { fetchPolicyStatement } from "../../api/SiteApi";
import withTracker from "../../utils/withTracker";

class PrivacyPage extends Component {
  state = {
    policyStatement: {}
  };

  componentDidMount = () => {
    fetchPolicyStatement().then(policyStatement => {
      this.setState({
        policyStatement
      });
    });
  };

  handleBackButton = () => {
    if (this.props.history.action === "PUSH") {
      this.props.history.goBack();
    } else {
      this.props.history.push("/");
    }
  };

  render() {
    const {site} = this.props;
    if (this.state.tocs === {}) {
      return null;
    }
    return (
      <Viewer>
        <AppBar showBackButton >
          <AppBarContentWrapper>
              {site && site.scriptDirection === "RTL" ? (
                <ForwardIcon size={24} onClick={this.handleBackButton} />
              ) : (
                <BackIcon size={24} onClick={this.handleBackButton} />
              )}
            </AppBarContentWrapper>
        </AppBar>
        <ContentWrapper>
          <div
            dangerouslySetInnerHTML={{
              __html: this.state.policyStatement[this.props.contentType]
            }}
          />
        </ContentWrapper>
      </Viewer>
    );
  }
}

PrivacyPage.propTypes = {
  history: PropTypes.shape({
    action: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired,
  contentType: PropTypes.string.isRequired,
  site: PropTypes.shape({
    scriptDirection: PropTypes.string.isRequired
  })
};

export default withRouter(withTracker(PrivacyPage));
